// components/OfficerTable.js
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import OfficerFormModal from "./OfficerFormModal";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import axios from "axios";

const OfficerTable = () => {
  const [officers, setOfficers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/officers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOfficers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will soft-delete the officer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
  
    if (confirm.isConfirmed) {
      const token = localStorage.getItem("token");
  
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/officers/update/${id}`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        Swal.fire("Deleted!", "Officer deleted.", "success");
        fetchData();
      } catch (err) {
        console.error("Delete error:", err.response || err.message);
        Swal.fire(
          "Error",
          err.response?.data?.error || "Failed to delete officer.",
          "error"
        );
      }
    }
  };
  

  const handleSubmit = async (data) => {
    try {
      const token = localStorage.getItem("token");
  
      if (editData) {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/officers/${editData.id}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
        Swal.fire("Updated!", "Officer updated successfully", "success");
      } else {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/officers`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        const { username, password } = response.data;
  
        Swal.fire({
          title: "Added!",
          html: `
            <p>Officer created successfully</p>
            <p><strong>Username:</strong> ${username}</p>
            <p><strong>Password:</strong> ${password}</p>
            <p style="color: red"><strong>Harap disalin, password tidak bisa dilihat kembali.</strong></p>
          `,
          icon: "success",
        });
      }
  
      fetchData();
      setShowModal(false);
      setEditData(null);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to save officer", "error");
    }
  };
  

  const columns = [
    { name: "Full Name", selector: row => row.full_name, sortable: true },
    { name: "Nickname", selector: row => row.nickname },
    { name: "Division", selector: row => row.division },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Button size="sm" variant="info" className="me-2" onClick={() => { setEditData(row); setShowModal(true); }}>Edit</Button>
          <Button size="sm" variant="danger" onClick={() => handleDelete(row.id)}>Delete</Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <h3>Officers</h3>
        <Button onClick={() => { setEditData(null); setShowModal(true); }}>
          Add Officer
        </Button>
      </div>
      <DataTable
        columns={columns}
        data={officers}
        pagination
        highlightOnHover
        responsive
      />
      <OfficerFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleSubmit={handleSubmit}
        initialData={editData}
      />
    </>
  );
};

export default OfficerTable;
